import React from 'react';
import { ApolloError } from '@apollo/client';

import {
  Typography,
  CircularProgress,
  LinearProgress,
  Card,
  CardContent,
} from '@occc-app/design-system';
import { CampaignFormRenderProps } from '@occc-app/routes/Campaign/types';

interface IUpdateCampaignFormProps extends Pick<CampaignFormRenderProps, 'handleSubmit'> {
  children?: React.ReactNode;
  loading: boolean;
  loaded: boolean;
  error?: ApolloError;
}

export const UpdateCampaignForm: React.FC<IUpdateCampaignFormProps> = ({
  handleSubmit,
  loading,
  loaded,
  error,
  children,
}) => {
  if (error) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }
  // initially loading
  if (loading && !loaded) {
    return <CircularProgress />;
  }

  if (!loaded) {
    return <Typography color='error'>No data. Something went wrong. Please try again.</Typography>;
  }

  return (
    <form onSubmit={handleSubmit} data-testid='campaign-update-form'>
      <Card>
        {loading && <LinearProgress />}
        <CardContent>{children}</CardContent>
      </Card>
    </form>
  );
};
